module.exports = __webpack_public_path__ + "images/130_2048.jpg";